<script setup lang="ts">
import SliderBar from '@/components/common/slidebar.vue'
import { seaTurtleApiClauseInfoGetByTypePost } from '@/services/api/CommonApi'

const { t } = useLang()
useHead({
  title: t('common.b_tdk_title'),
  meta: [
    { name: 'keywords', content: t('common.b_tdk_keywords') },
    { name: 'description', content: t('common.b_tdk_description') },
    { name: 'author', content: t('common.b_author') },
    { name: 'copyright', content: t('common.b_company') },
  ],
})

const categoryId = ref('')
const pageName = ref('')
const pageContent = ref('')

onMounted(() => {
  setTimeout(() => {
    if (process.client) {
      seaTurtleApiClauseInfoGetByTypePost({
        agreementType: 4,
      }).then((res) => {
        pageName.value = res?.showName || ''
        pageContent.value = res?.clauseText || ''
      })
    }
  })
})
</script>

<template>
  <div class="content clearfix">
    <SliderBar :category-id="categoryId" />
    <div class="right_main">
      <div class="aboutus show_con">
        <div class="title">
          {{ pageName }}
        </div>
        <div class="main_content">
          <!-- <p>{{ t('company.b_company_label0') }}</p>
          <p><span>{{ t('company.b_company_label1') }}</span> {{ t('company.b_company_label2') }}</p>
          <p>{{ t('company.b_company_label3') }}</p>
          <p>{{ t('company.b_company_label4') }}</p> -->
          <p v-html="pageContent" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import url('@/assets/css/common/index.scss');
</style>
